/* Cart auto-update.
 *
 * Changing a quantity, or clicking Remove, updates the cart over the AJAX API
 * instead of requiring a separate "Update" submit. The button stays in the markup
 * and is hidden here, so a browser without JS still has a working cart.
 *
 * Money strings are not formatted client-side. After a successful change the cart
 * page is re-fetched and only the item list and the total figures are swapped in,
 * so the values keep Shopify's own money formatting and stay consistent with any
 * discounts. Swapping just those nodes also leaves the delivery block untouched —
 * re-rendering it would drop the chosen delivery method and unbind the datepicker.
 */
(function () {
  var form = document.getElementById('wf-form-Cart');
  if (!form || !window.fetch || !Element.prototype.closest) return;

  var updateButton = form.querySelector('.cart-update');
  if (updateButton) updateButton.hidden = true;

  // Serialise requests: two quick edits must not race and clobber each other.
  var queue = Promise.resolve();
  var inFlight = 0;

  function setBusy(busy) {
    inFlight += busy ? 1 : -1;
    form.classList.toggle('cart-busy', inFlight > 0);
  }

  function lineOf(row) {
    var rows = form.querySelectorAll('.cart-item-2');
    return Array.prototype.indexOf.call(rows, row) + 1; // Shopify lines are 1-based
  }

  function refresh() {
    return fetch(window.location.pathname, {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart reload failed');
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var freshItems = doc.querySelector('.cart-items');

        // No item list in the response means the cart is now empty, which renders a
        // different template. Nothing to patch — let the page render itself.
        if (!freshItems) {
          window.location.reload();
          return;
        }

        var currentItems = form.querySelector('.cart-items');
        if (currentItems) currentItems.innerHTML = freshItems.innerHTML;

        ['.cart-summary__figures', '.cart-stickybar__total'].forEach(function (sel) {
          var fresh = doc.querySelector(sel);
          var current = form.querySelector(sel);
          if (fresh && current) current.innerHTML = fresh.innerHTML;
        });
      });
  }

  function changeLine(line, quantity) {
    setBusy(true);
    queue = queue
      .then(function () {
        return fetch(window.location.origin + '/cart/change.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: line, quantity: quantity })
        });
      })
      .then(function (r) {
        if (!r.ok) throw new Error('cart change failed: ' + r.status);
        return r.json();
      })
      .then(refresh)
      .catch(function () {
        // Never leave the customer looking at numbers that no longer match the cart.
        window.location.reload();
      })
      .then(function () {
        setBusy(false);
      });
    return queue;
  }

  // Delegated: the item list is replaced wholesale on every refresh.
  form.addEventListener('change', function (event) {
    var input = event.target.closest ? event.target.closest('.snoop-cart-quantity') : null;
    if (!input) return;
    var row = input.closest('.cart-item-2');
    if (!row) return;

    var quantity = parseInt(input.value, 10);
    if (isNaN(quantity) || quantity < 0) quantity = 0;
    input.value = quantity;

    changeLine(lineOf(row), quantity);
  });

  form.addEventListener('click', function (event) {
    var link = event.target.closest ? event.target.closest('.remove-link') : null;
    if (!link) return;
    var row = link.closest('.cart-item-2');
    if (!row) return;

    event.preventDefault();
    changeLine(lineOf(row), 0);
  });
})();
